import React, { useState } from 'react';
import withStyles from '@mui/styles/withStyles';
import TableKey from '../page/workQueue2/extras/TableKey';
import Popover from '@mui/material/Popover';
import Icon from '@mui/material/Icon';
import Button from '@mui/material/Button';
import { getOffices } from '../environment';

const BrandedTableKey = ({ classes }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const allOffices = getOffices();
    return (
        <>
            <Button className={classes.capsuleContent} onClick={evt => setAnchorEl(evt.currentTarget)}>
                Office Colours <Icon className={classes.tipContent}>keyboard_arrow_down</Icon>
            </Button>
            <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
            >
                <div className={classes.popContent}>
                    {allOffices.map(({ RegistrantSuffix }, idx) => (
                        <TableKey key={idx} legacyKey={RegistrantSuffix} />
                    ))}
                </div>
            </Popover>
        </>
    );
};

const styles = theme => ({
    popContent: {
        padding: '1rem 0 0.5rem 16px',
        [theme.breakpoints.down('lg')]: {
            padding: '10px 0 10px 10px'
        }
    },
    tipContent: {
        fontSize: 16
    },
    capsuleContent: {
        fontSize: 12,
        textTransform: 'unset'
    }
});
export default withStyles(styles)(BrandedTableKey);
